import config from "@config"

const currentTemplate = config.template.name || "base"

export default import(`../${currentTemplate}/config/graphql.json`)
